import ApiService from "../api-service";
import {
	DEFAULT_ERROR_MESSAGE,
	JEET_11_PARTNER,
	JEET_11_DISTRIBUTOR,
	JEET_11_EXECUTIVE,
	JEET_11_CAPTAIN,
	JEET_11_PROMOTER,
	JEET_11_TSM,
	JEET_11_RBM
} from "../config";
import { BASE_URL } from "../../../config";
import {
	USER_SIGN_IN,
	USER_LOG_OUT,
	USER_FORGOT_PASSWORD_SEND_OTP,
	USER_RESET_PASSWORD,
	SHOW_ALERT,
	RESET_RETAIL_MODULE,
	RESET_COMMON_MODULE,
	RESET_SIGNUP_MODULE,
	RESET_UPLOAD_MODULE,
	RESET_USER_MODULE,
	RESET_PAYMENT_MODULE,
	RESET_JEET11_MODULE
} from "../action-types";
import { signInSuccess, resetAppState } from "../mutation-types";

const state = {
	ACCESS_TOKEN: null,
	AUTH_TOKEN: null,
	USERID: null,
	USERNAME: null,
	REVIEWER: null,
	TEAM_TYPE: null,
	activeLang: null,
	storeType: false,
	shopType: false
};

const initialState = Object.assign({}, state);

const getters = {
	isRetailAdmin: state => {
		return state.TEAM_TYPE === "retailAdmin";
	},
	isRetailer: state => {
		return state.TEAM_TYPE === "retail";
	},
	isJeet11Partner: state => {
		return (
			state.storeType === JEET_11_PARTNER && state.TEAM_TYPE === "retail"
		);
	},
	isJeet11Captain: state => {
		return (
			state.storeType === JEET_11_CAPTAIN && state.TEAM_TYPE === "retail"
		);
	},
	isJeet11TSM: state => {
		return state.storeType === JEET_11_TSM && state.TEAM_TYPE === "retail";
	},
	isJeet11RBM: state => {
		return state.storeType === JEET_11_RBM && state.TEAM_TYPE === "retail";
	},
	isJeet11Distributor: state => {
		return (
			state.storeType === JEET_11_DISTRIBUTOR &&
			state.TEAM_TYPE === "retail"
		);
	},
	isFinanceAdmin: state => {
		return state.TEAM_TYPE === "financeAdmin";
	},
	isJeet11Executive: state => {
		return (
			state.storeType === JEET_11_EXECUTIVE &&
			state.TEAM_TYPE === "retail"
		);
	},
	isJeet11Promoter: state => {
		return (
			state.storeType === JEET_11_PROMOTER && state.TEAM_TYPE === "retail"
		);
	},
	isOnlineUser: state => {
		return (
			(state.storeType === JEET_11_PARTNER ||
				state.storeType === JEET_11_EXECUTIVE ||
				state.storeType === JEET_11_DISTRIBUTOR) &&
			state.shopType === "online" &&
			state.TEAM_TYPE === "retail"
		);
	}
};

const actions = {
	[USER_SIGN_IN.action]: ({ commit, dispatch }, payload) => {
		const endpoint = BASE_URL + "/login";
		const requestPayload = {
			action: "login",
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log("LOGIN : ", data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const rawResp = data.response;
						if (
							rawResp.team === "retail" ||
							rawResp.team === "retailAdmin" ||
							rawResp.team === "financeAdmin"
						) {
							if (rawResp.storeType === "dstr") {
								rawResp.storeType = JEET_11_DISTRIBUTOR;
							} else if (rawResp.storeType === "dstrRetail") {
								rawResp.storeType = JEET_11_PARTNER;
							} else if (rawResp.storeType === "executive") {
								rawResp.storeType = JEET_11_EXECUTIVE;
							} else if (rawResp.storeType === "captain") {
								rawResp.storeType = JEET_11_CAPTAIN;
							} else if (rawResp.storeType === "promoter") {
								rawResp.storeType = JEET_11_PROMOTER;
							} else if (rawResp.storeType === "tsm") {
								rawResp.storeType = JEET_11_TSM;
							} else if (rawResp.storeType === "rbm") {
								rawResp.storeType = JEET_11_RBM;
							}
							commit(signInSuccess, {
								reqPayload: payload,
								response: {
									...rawResp,
									botUserId: rawResp.mappedUsers[0]
								}
							});
							return;
						} else {
							errMsg = "You are not authorized!";
						}
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
					throw new Error(errMsg);
				}
			})
			.catch(err => {
				console.error(err);
				// const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				const errMsg =
					"Either the username/password is incorrect, or you have not been approved yet";
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[USER_LOG_OUT.action]: ({ commit, dispatch }) => {
		commit(resetAppState);
		dispatch(RESET_RETAIL_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_COMMON_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_SIGNUP_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_UPLOAD_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_USER_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_PAYMENT_MODULE.dispatch, {}, { root: true });
		dispatch(RESET_JEET11_MODULE.dispatch, {}, { root: true });
	},
	[USER_FORGOT_PASSWORD_SEND_OTP.action]: ({ dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/forgotPasswordSendOtp";
		const requestPayload = {
			params: {
				phone: payload.phone,
				countryAreaCode: payload.countryAreaCode
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log("FORGOT_PASSWORD_SEND_OTP : ", data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const rawResp = data.response;
						if (typeof rawResp.id === "string") {
							return rawResp.id;
						}
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
					throw new Error(errMsg);
				}
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[USER_RESET_PASSWORD.action]: ({ dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/resetPassword";
		const requestPayload = {
			params: {
				id: payload.id,
				newPassword: payload.newPassword,
				otp: Number(payload.otp)
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log("FORGOT_PASSWORD_VERIFY_OTP : ", data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const rawResp = data.response;
						if (rawResp.status === "success") {
							const text =
								rawResp.message ||
								"Password changed successfully";
							dispatch(
								SHOW_ALERT.dispatch,
								{ text },
								{ root: true }
							);
							return;
						}
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
					throw new Error(errMsg);
				}
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	}
};

const mutations = {
	[signInSuccess](state, { reqPayload, response }) {
		let tokenData = response.access_token;
		let temp = tokenData.split(":");
		state.USERID = response.mappedUsers[0];
		state.ACCESS_TOKEN = tokenData;
		state.USERNAME = reqPayload.username;
		state.REVIEWER = `${reqPayload.username}:${temp[0]}`;
		state.TEAM_TYPE = response.team;
		state.storeType = response.storeType;
		state.activeLang = response.lang;
		state.shopType = response.shopType;
	},
	[resetAppState](state) {
		Object.keys(initialState).forEach(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};
